export enum RooftopAuthorizationRequestStatus {
  PENDING = 'pending',
  COMPLETED = 'completed',
}